import { useRouteMatch } from 'react-router';
import { generatePath } from 'react-router-dom';
import pages from '../routes/pages';

interface UsePublicShopReturn {
  isPublicShop: boolean;
  shopId?: string;
  shopUrl?: string;
  classeId?: string;
}

const usePublicShop = (): UsePublicShopReturn => {
  const { params } = useRouteMatch<{ shopId?: string; classeId?: string }>();
  return {
    isPublicShop: !!params.shopId,
    shopId: params.shopId,
    classeId: params.classeId,
    shopUrl:
      !!params.shopId && generatePath(pages.PUBLIC_SHOP_HOME.path, params)
  };
};

export default usePublicShop;
